import './owl.carousel';

(function ($) {
  // Main Carousel: Small device
  $('.main-carousel-sm').owlCarousel({
    autoplay: true,
    loop: true,
    margin: 0,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 1,
      }
    }
  });

  // Main Carousel: Large device
  $('.main-carousel-lg').owlCarousel({
    autoplay: true,
    loop: true,
    margin: 0,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 1,
      }
    }
  });
})(jQuery);
